import axios from 'axios'
import axiosOfflineInterceptor from '@/utils/axiosOfflineInterceptor'

export async function initServices () {
  // Create base axios instance
  const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 30000
  })

  // Setup offline interceptor
  // DISABLED: Service worker handles offline queueing to avoid duplicate queue systems
  axiosOfflineInterceptor.setupInterceptor(axiosInstance)

  return axiosInstance
}
